<template>
  <div class="card-custom-height">
    <div class="w-full h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mt-5px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="请输入姓名、联系电话"
          v-model="searchData.nameOrPhoneNumber"
          clearable
        ></el-input>
        <el-select
          v-model="searchData.status"
          size="small"
          class="mr-10px !w-50"
          placeholder="人员状态"
          filterable
          clearable
        >
          <el-option
            v-for="item in statusFilterList"
            :key="item.code"
            :label="item.displayName"
            :value="Number(item.code)"
          ></el-option>
        </el-select>
        <el-select
          v-model="searchData.isBlock"
          size="small"
          class="mr-10px !w-50"
          placeholder="是否黑名单"
          filterable
          clearable
        >
          <el-option
            v-for="item in blackList"
            :key="item.code"
            :label="item.displayName"
            :value="item.code"
          ></el-option>
        </el-select>
        <el-button size="small" type="primary" @click="handleSearch">搜索</el-button>
      </div>
      <el-table
        :data="dataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="tableLoading"
      >
        <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
        <el-table-column
          label="姓名"
          align="center"
          prop="name"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属单位"
          align="center"
          prop="contractorName"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属项目"
          align="center"
          prop="projectNames"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="联系电话"
          align="center"
          prop="phoneNumber"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="年龄"
          align="center"
          prop="age"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="是否特种人员"
          align="center"
          prop="isSpecialOperationCertificatePersonnel"
          width="120"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.isSpecialOperationCertificatePersonnel">是</el-tag>
            <el-tag size="mini" type="info" v-if="!scope.row.isSpecialOperationCertificatePersonnel"
              >否</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="工种" align="center" prop="jobs" width="100">
          <template slot-scope="scope">
            <span>{{ jobsMap(scope.row.jobs) }}</span>
          </template>
        </el-table-column>
        <el-table-column width="100" label="是否黑名单" prop="isBlock">
          <template slot-scope="scope">
            <el-tag size="mini" type="danger" v-if="scope.row.isBlock === true">是</el-tag>
            <el-tag size="mini" type="success" v-else-if="scope.row.isBlock === false">否</el-tag>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="人员状态" align="center" prop="status" width="100">
          <template slot-scope="scope">
            <el-tag size="mini" :type="unitStatusTypes(scope.row.status)">{{
              unitStatusMap(scope.row.status)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" v-if="$hasAccess('read')"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="tableSizeChange"
        @current-change="tableCurrentChange"
        :current-page.sync="pageConfig.SkipCount"
        :page-size.sync="pageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="totalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <!-- 详情 -->
    <div v-if="currentComp === 'DETAIL'" class="w-full h-full">
      <div class="flex justify-between items-center">
        <div class="title text-lg mb-10px cursor-pointer">
          <el-page-header @back="handleBack" content="人员详情"></el-page-header>
        </div>
      </div>
      <div class="w-full detail-height">
        <person-enter-content
          :FormData="FormData"
          :formList="formList"
          @back="handleBack"
          @save="handleBack"
          pageType="detail"
        ></person-enter-content>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import {
  ContractorPersonnelApi,
  ContractorPersonnelCertificateApi,
  GuidanceConfigurationApi,
  ContractorPersonnelConfigurationApi,
} from '@wiz-api/contractor-management'
import { AbpApplicationConfigurationApi } from '@wiz-api/abp-application'
import { DataCategoryApi } from '@wiz-api/data-category-management'
import PersonEnterContent from '@/components/safety/WizSafetyPage/PersonEnterContent'
import { unitStatusTypes } from '@/components/safety/enumField/enumTypeMethods'

const contractorPersonnelApi = new ContractorPersonnelApi()
const dataCategoryApi = new DataCategoryApi()
const abpApplicationConfigurationApi = new AbpApplicationConfigurationApi()
const guidanceConfigurationApi = new GuidanceConfigurationApi()
const contractorPersonnelCertificateApi = new ContractorPersonnelCertificateApi()
const contractorPersonnelConfigurationApi = new ContractorPersonnelConfigurationApi()

export default {
  name: 'applicants-info',
  components: {
    PersonEnterContent,
  },
  props: {
    contractId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      blackList: [
        { code: true, displayName: '是' },
        { code: false, displayName: '否' },
      ],
      jobsList: [],
      formList: [],
      currentComp: 'TABLE',
      FormData: {},
      statusList: [],
      row: null,
      multipleSelect: [],
      tableLoading: false,
      dataList: [],
      totalCount: 0,
      searchData: {
        contractorId: this.contractId,
        nameOrPhoneNumber: '',
        status: '',
        isArchives: true,
      },
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  created() {
    this.getConfig()
    this.getList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 105px)'
    },
    unitStatusTypes() {
      return (val) => {
        return unitStatusTypes(val)
      }
    },
    statusFilterList() {
      return this.statusList.filter((item) => {
        return item.code !== '0' && item.code !== '3'
      })
    },
    unitStatusMap() {
      return (val) => {
        return (
          this.statusList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
    jobsMap() {
      return (val) => {
        return (
          this.jobsList.find((i) => {
            // eslint-disable-next-line eqeqeq
            return i.code == val
          })?.displayName || ''
        )
      }
    },
  },
  methods: {
    // 获取数据字典
    async getConfig() {
      let ids = []
      const [configError, abpConfigList] = await abpApplicationConfigurationApi.get()
      if (!configError) {
        const [statusError, statusRes] = await dataCategoryApi.getListByCodes({
          codes: [
            abpConfigList.setting.values['ContractorManagement.DataCategory.IncomingfactoryStatus'],
            abpConfigList.setting.values['ContractorManagement.DataCategory.Jobs'],
          ],
          includeDetails: true,
        })
        if (!statusError) {
          ids = statusRes.map((item) => {
            return item.id
          })
          this.getItemsByIds(ids)
        }
      }
    },
    // 获取数据字典列表
    async getItemsByIds(ids) {
      const [err, res] = await dataCategoryApi.getListByIds({
        ids,
        includeDetails: true,
      })
      if (!err) {
        // 承包商入厂状态
        this.statusList = res.filter((item) => {
          return item.code === 'IncomingfactoryStatus'
        })[0].dataItems

        // 工种
        this.jobsList = res.filter((item) => {
          return item.code === 'Jobs'
        })[0].dataItems
      }
    },
    // 初始化表单
    initForm() {
      this.FormData = {
        infDocFileName: '',
        infDocFileId: '',
        name: '',
        phoneNumber: '',
        age: null,
        idCard: '',
        sex: null,
        national: '',
        education: null,
        isTemp: true,
        personnelCategory: null,
        team: null,
        dutieJob: null,
        isSpecialOperationCertificatePersonnel: true,
        contractorId: '',
        projectId: '',
        headshotFileId: '',
        idCardFrontFileId: '',
        idCardReverseFileId: 0,
        jobs: null,
        contractorPersonnelConfigurations: [],
        contractorPersonnelCertificates: [],
      }
    },
    // 返回页面
    handleBack() {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = 'TABLE'
      })
      this.getList()
    },
    // 详情
    async handleEdit(row) {
      this.initForm()
      const [error, result] = await contractorPersonnelApi.get(row.id)
      if (!error) {
        this.FormData = {
          ...this.FormData,
          ...result,
        }
        // 获取证书是否提供
        const [
          errCard,
          resCard,
        ] = await contractorPersonnelCertificateApi.contractorPersonnelCertificateDto({
          contractorPersonnelId: row.id,
        })
        if (!errCard) {
          // 时间格式化
          resCard.forEach((item) => {
            item.certificateDate = dayjs(item.certificateDate).format('YYYY-MM-DD')
          })
          this.$set(this.FormData, 'contractorPersonnelCertificates', resCard)
        }
        // 获取资料是否提供
        const [
          err,
          res,
        ] = await contractorPersonnelConfigurationApi.contractorPersonnelConfiguration({
          contractorPersonnelId: row.id,
        })
        if (!err) {
          this.formList = res.map((item, index) => {
            return {
              id: item.id,
              configurationId: item.configurationId,
              label: item.title,
              field: `field${index}`,
              textfield: `textfield${index}`,
              // 获取有无情况以及说明
              isProvided: item.isProvided,
              description: item.description,
              isRequired: item.isRequired,
            }
          })
          this.currentComp = null
          this.$nextTick(() => {
            this.currentComp = 'DETAIL'
          })
        }
      }
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 获取人员列表
    async getList() {
      this.tableLoading = true
      this.multipleSelect = []
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      const [err, res] = await contractorPersonnelApi.pagedListQuery(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
        this.tableLoading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}

.detail-height {
  height: calc(100% - 52px);
}

.card-custom-height {
  height: calc(100% - 50px);
}
</style>
